import s from './Account.module.css';
import {useSelector} from "react-redux";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {NavLink} from "react-router-dom";


const AccountAdress = () => {

    const userInfo = useSelector(state => state.setUserData);

    return (
        <div className={s.adress}>
            <h3>Мои Адреса</h3>
            <div className={s.adressItem}>
                <div className={s.adressTitles}>
                    <h5>Адрес</h5>
                    <h5>Действия</h5>
                </div>
                <div className={s.adressInfo}>
                    <div>
                        <p>{`${userInfo.name + " " + userInfo.surname}`}</p>
                        <p>{`${userInfo.country}, ${userInfo.region}, ${userInfo.city}, ${userInfo.address}`}</p>
                    </div>
                    <div className={s.adressControls}>
                        <BuyButton><NavLink to="/account/edit-adress">Редактировать</NavLink></BuyButton>
                        <BuyButton fastorder>Удалить</BuyButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountAdress;